export default __webpack_public_path__ + "static/nihr-8f0f74215fb7c54a7a0c42d46f9ae819.png";